import Attach from '../../../../_00_elements/tools/attach';
import { URL_REGISTER_MISSING_EMAIL } from '../../../../_00_elements/tools/routes/routes';
import TwigFormValidator from '../../../../_00_elements/tools/twig-form/validator';
import { hideSubmitLoader } from '../../../../_01_atoms/spinner';
import Modal from '../../../../_01_atoms/components/Modal.vue';
import requests from '../../../../_00_elements/tools/requests-mixin';
import eventBus from '../../../../_00_elements/tools/event-bus';

/**
 * Missing Email Modal Component
 * This component use the modal component as a child.
 * It displays the missing email form for the user to fill.
 */
export default {
  template: '#user-modal-component',
  components: {
    Modal,
  },
  props: [ 'isOpened' ],
  mixins: [ requests ],
  delimiters: [ '${', '}' ],
  data() {
    return {
      htmlBody: '',
      modalTitle: '',
    };
  },
  methods: {
    switchTo(newModalName, args) {
      this.htmlBody = '';
      this.modalTitle = '';
      eventBus.dispatchEvent(new CustomEvent('switch-from-to-modal', {
        detail: {
          oldModalName: 'MissingEmail',
          newModalName,
          args,
        },
      }));
    },
    close() {
      this.htmlBody = '';
      this.modalTitle = '';
      this.$emit('close');
    },
    /**
     * initForm
     * @param id
     * @description validate form using specific rules
     */
    initForm() {
      this.$nextTick(() => {
        const validator = new TwigFormValidator({
          formSelector: '#form-missing-email',
          rules: {
            'app_user_email_missing[email]': [ 'required', 'email' ],
          },
          onSuccess: (event) => {
            Attach.asyncSubmit(event, URL_REGISTER_MISSING_EMAIL)
              .then((result) => {
                this.htmlBody = result.data;

                this.$nextTick(() => {
                  if (document.getElementById('check-email-continue')) {
                    Attach.onClickEvent('check-email-continue', () => {
                      this.close();
                    });
                  } else if (document.getElementById('open_login_modal_with_email')) {
                    Attach.onClickEvent('open_login_modal_with_email', () => {
                      const email = document.getElementById('app_user_email_missing_email').value;
                      this.switchTo('Login', [ email ]);
                    });
                  }
                  this.initForm();
                });
              })
              // init input placeholder animation after html added
              .then(this.$nextTick(() => {
                this.initFormValidation();
                hideSubmitLoader('#app_user_email_missing_save');
              }));
          },
        });
        validator.init();
      });
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }

      const currentRoute = window.location.hash;
      const information = currentRoute.replace('#missing_', '').split('-');

      this
        .get(URL_REGISTER_MISSING_EMAIL, { params: { missing: information } })
        .then((response) => {
          this.htmlBody = response.data;

          this.$nextTick(() => {
            this.initForm();
          });
        }).catch(() => {
          this.close();
        });
    },
  },
};
